import React from 'react';
import style from '../css/Policy.module.css';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';

function Policy() {
	return (
		<div className={style.container}>
			{/* top section */}
			<div className={style.headerBack}>
				<div className={style.btnRow}>
					<Link className={style.btn} to={'/'}>
						Home
					</Link>
					<p>|</p>
					<Link className={style.btn} to={'/privacy-policy'}>
						Privacy Policy
					</Link>
				</div>

				<div className={style.btnRow}>
					<Link className={style.btn} to={'/privacy-policy'}>
						Privacy & Policy
					</Link>
					<p>|</p>
					<Link className={style.btn} to={'/terms-and-conditions'}>
						Terms & Conditions
					</Link>
				</div>

				<h4>Privacy Policy of HomeTech Repair</h4>
			</div>

			<div className={style.textDiv}>
				<h2>PERSONAL DATA</h2>
				<p>
					User hereunder brought up as You and HomeTech Repair. HomeTech Repair
					is owner and operator of www.doorstephub.com (the Website), HomeTech
					Repair's Mobile Application for on-demand home services and Repairs
					(HomeTech Repair App), collectively, as well as all content provided
					by HomeTech Repair through the HomeTech Repair App and also the
					website HomeTech Repair Services.
				</p>
				<p>
					You have the right to not provide personally classifiable data. If you
					plan to use HomeTech Repair Services and/or share your information
					with the HomeTech Repair Service, it's only at your own volition, risk
					and after reading and confirming this Privacy Policy.
				</p>
				<p>
					At the time of using the HomeTech Repair Service you may share certain
					Personal data with HomeTech Repair, which respects your data. Such
					data might include personally classifiable information like your name,
					address, mobile number, email ID, IP address and other personal
					details that you share in connection with the services.
				</p>
				<p>
					When you use HomeTech Repair’s Service through the App, HomeTech
					Repair might use your device’s ID to store your preferences and track
					usage. You agree HomeTech Repair has the right to share such ID with
					third parties for promotions, research, etc.
				</p>
				<p>
					If you participate in other schemes or services, additional data may
					be required and stored as confidential.
				</p>

				<h2>PROTECTION OF KNOWLEDGE AND STORAGE</h2>
				<p>
					HomeTech Repair takes necessary and reasonable precautions, but you
					are cautioned that the service may be vulnerable to hacking, virus
					attacks, and data risks.
				</p>

				<h2>ADVERTISEMENTS</h2>
				<p>
					HomeTech Repair may display advertisements provided by third-party
					Advertisers. HomeTech Repair does not guarantee or endorse these
					advertisers, their products, or services.
				</p>

				<h2>PRE-APPROVED SHARING OF PRIVATE INFO</h2>
				<p>
					HomeTech Repair may share your data with sponsors, service providers,
					and business partners to offer newsletters, offers, new products,
					services, and other relevant content. In legal matters or compliance
					with authorities, your data may be disclosed without prior consent.
				</p>

				<h2>CHANGES TO PRIVACY POLICY</h2>
				<p>
					HomeTech Repair reserves the right to update or amend this policy at
					any time. Continued use of the services implies acceptance of the
					updated policy.
				</p>
				<p>Contact: help@doorstephub.com</p>

				<h2>TERMS AND CONDITIONS FOR SERVICE PROVIDERS</h2>

				<h3>TERMS</h3>
				<p>
					By accessing HomeTech Repair, you agree to these terms, applicable
					laws, and local regulations. Content is protected by copyright and
					trademark law.
				</p>

				<h3>DISCLAIMER</h3>
				<p>
					HomeTech Repair provides content "as is" with no warranties, express
					or implied. It does not guarantee accuracy or reliability.
				</p>

				<h3>LIMITATIONS</h3>
				<p>
					HomeTech Repair is not liable for damages resulting from use or
					inability to use its content, to the extent permitted by law.
				</p>

				<h3>REVISIONS AND ERRATA</h3>
				<p>
					Content may contain errors. HomeTech Repair may update content without
					notice but does not commit to doing so.
				</p>

				<h3>LINKS</h3>
				<p>
					HomeTech Repair is not responsible for content on third-party sites
					linked through the service.
				</p>

				<h3>SITE OR APP TERMS MODIFICATIONS</h3>
				<p>
					Terms may change at any time. Continued use constitutes acceptance of
					current terms.
				</p>

				<h3>GOVERNING LAW</h3>
				<p>
					Governed by the laws of the respective state. General Terms apply.
				</p>

				<h2>PAYMENT AND REFUNDS</h2>
				<p>
					Payments should be made only after confirming satisfactory work.
					Refunds are not generally applicable unless formally addressed to the
					company, and will be subject to GST deductions and call-based
					processing.
				</p>

				<h2>PENALTY</h2>
				<p>
					If a vendor does not respond to an inquiry within 30 minutes, the lead
					is canceled and a penalty of ₹75 applies. Service must be completed
					within 8 hours of lead pickup to avoid cancellation and penalty.
				</p>
			</div>

			<Footer />
		</div>
	);
}

export default Policy;
